import { useMemo } from "react";
import useAccount from "@/modules/account/hooks/useAccount";
import { SYSTEM_ROLE_CODE } from "@/schemas/user";

export const useIsVisitEditableForRegionalRepresentative = (
  editableByRegionalRepresentative?: boolean,
) => {
  const { account } = useAccount();

  return useMemo(() => {
    if (
      account?.system_role_code !== SYSTEM_ROLE_CODE.REGIONAL_REPRESENTATIVE
    ) {
      return true;
    }
    return editableByRegionalRepresentative !== false;
  }, [account?.system_role_code, editableByRegionalRepresentative]);
};
